import React from "react";
import Select from "react-select";
import ParametresMargeModal from "./ParametresMargeModal.jsx";
import {
  ALEAS,
  ALEAS_PERTES,
  NIVEAUX_RISQUE,
  RCP_OPTIONS,
  POLITIQUES,
  EQUIPEMENTS,
} from "../constants.js";

export default function Sidebar(props) {
  const {
    config,
    cultureOption,
    setCultureOption,
    region,
    setRegion,
    modeRcp,
    setModeRcp,
    prixVente,
    setPrixVente,
    onglet,
    pertesRisque,
    setPertesRisque,
    ecart2020,
    setEcart2020,
    typeMarge,
    setTypeMarge,
    parHa,
    setParHa,
    fraisCultureHorsIrrigation,
    setFraisCultureHorsIrrigation,
    equipParams,
    setEquipParams,
    equipement,
    setEquipement,
    lissage,
    setLissage,
    prixEau,
    setPrixEau,
    prixElec,
    setPrixElec,
  } = props;

  const selectStyles = {
    control: (base) => ({ ...base, minHeight: 34 }),
  };

  return (
    <aside className="diagoeau-sidebar">
      <div className="diagoeau-field">
        <label>Culture</label>
        <Select
          options={config?.cultures ?? []}
          value={cultureOption ?? null}
          onChange={(option) => setCultureOption(option ?? null)}
          placeholder="Rechercher une culture..."
          isClearable
          noOptionsMessage={() => "Aucune culture trouvée"}
          styles={selectStyles}
        />
      </div>

      <div className="diagoeau-field">
        <label>Petite région agricole</label>
        <Select
          options={config?.libelles ?? []}
          value={region ?? null}
          onChange={(option) => setRegion(option ?? null)}
          placeholder="Rechercher une région..."
          isClearable
          noOptionsMessage={() => "Aucune région trouvée"}
          styles={selectStyles}
        />
      </div>

      <div className="diagoeau-field diagoeau-radio-group">
        <label>Scénario climatique</label>
        {RCP_OPTIONS.map((o) => (
          <label key={o.value}>
            <input
              type="radio"
              name="mode_rcp"
              value={o.value}
              checked={modeRcp === o.value}
              onChange={() => setModeRcp(o.value)}
            />
            {o.label}
          </label>
        ))}
      </div>

      <hr />
      {/* {["marge", "subvention", "economie"].includes(onglet) && ( */}
      {["marge"].includes(onglet) && (
        <div className="diagoeau-field">
          <label>Prix du maïs (€/t)</label>
          <input
            type="number"
            step={5}
            value={prixVente}
            onChange={(e) => setPrixVente(Number(e.target.value))}
          />
        </div>
      )}

      {onglet === "phenologie" && (
        <p className="diagoeau-help-text">
          Progression phénologique (degrés-jours) pour 3 horizons.
        </p>
      )}

      {onglet === "eau" && <EauPanel {...props} />}

      {onglet === "aleas" && (
        <p className="diagoeau-help-text">
          Nombre de jours par an avec aléas (gel, CDC, SHRU, EE, CDF) pour 3 horizons.
        </p>
      )}

      {onglet === "pertes" && <PertesPanel {...props} />}
      {onglet === "marge" && <MargePanel {...props} />}
      {/* {onglet === "subvention" && <SubventionPanel {...props} />} */}
    </aside>
  );
}

function EauPanel({ ecart2020, setEcart2020 }) {
  return (
    <>
      <div className="diagoeau-field diagoeau-checkbox-row">
        <label>
          <input
            type="checkbox"
            checked={ecart2020}
            onChange={(e) => setEcart2020(e.target.checked)}
          />
          Écart à 2020
        </label>
      </div>
      <p className="diagoeau-help-text">
        Besoin en eau et irrigation journaliers, depuis le semis.
        {ecart2020 && " Affichage en écart (2035-2020, 2050-2020)."}
      </p>
    </>
  );
}

function PertesPanel({ pertesRisque, setPertesRisque }) {
  return (
    <>
      <div className="diagoeau-field">
        <label>Niveau de risque</label>
        <select value={pertesRisque} onChange={(e) => setPertesRisque(e.target.value)}>
          {NIVEAUX_RISQUE.map((r) => (
            <option key={r} value={r}>
              {r}
            </option>
          ))}
        </select>
      </div>
      <p className="diagoeau-help-text">
        Perte totale (%) par horizon, et répartition par aléa (camemberts).
      </p>
    </>
  );
}

function MargePanel({
  typeMarge,
  setTypeMarge,
  parHa,
  setParHa,
  fraisCultureHorsIrrigation,
  setFraisCultureHorsIrrigation,
  equipParams,
  setEquipParams,
  equipement,
  setEquipement,
  lissage,
  setLissage,
  prixEau,
  setPrixEau,
  prixElec,
  setPrixElec,
}) {
  const [modalOpen, setModalOpen] = React.useState(false);

  return (
    <>
      <div className="diagoeau-field diagoeau-radio-group">
        <label>Affichage</label>
        <label>
          <input
            type="radio"
            checked={typeMarge === "annuelle"}
            onChange={() => setTypeMarge("annuelle")}
          />
          Marge par année
        </label>
        <label>
          <input
            type="radio"
            checked={typeMarge === "cumul"}
            onChange={() => setTypeMarge("cumul")}
          />
          Marge cumulée
        </label>
      </div>

      <div className="diagoeau-field diagoeau-checkbox-row">
        <label>
          <input
            type="checkbox"
            checked={parHa}
            onChange={(e) => setParHa(e.target.checked)}
          />
          Marge par hectare
        </label>
      </div>

      <div className="diagoeau-field diagoeau-radio-group">
        <label>Équipement</label>
        {EQUIPEMENTS.map((eq) => (
          <label key={eq.value}>
            <input
              type="radio"
              checked={equipement === eq.value}
              onChange={() => setEquipement(eq.value)}
            />
            {eq.label}
          </label>
        ))}
      </div>

      <div className="diagoeau-field">
        <button className="diagoeau-btn" onClick={() => setModalOpen(true)}>
          Affiner les paramètres
        </button>
      </div>

      <ParametresMargeModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        fraisCultureHorsIrrigation={fraisCultureHorsIrrigation}
        setFraisCultureHorsIrrigation={setFraisCultureHorsIrrigation}
        equipParams={equipParams}
        setEquipParams={setEquipParams}
        equipement={equipement}
        lissage={lissage}
        setLissage={setLissage}
        prixEau={prixEau}
        setPrixEau={setPrixEau}
        prixElec={prixElec}
        setPrixElec={setPrixElec}
      />
    </>
  );
}

function SubventionPanel({
  tauxActu,
  setTauxActu,
  polSubv,
  setPolSubv,
}) {
  return (
    <>
      <div className="diagoeau-field">
        <label>Taux d'actualisation (%)</label>
        <input
          type="number"
          min={0}
          max={15}
          step={0.5}
          value={tauxActu}
          onChange={(e) => setTauxActu(Number(e.target.value))}
        />
      </div>

      <div className="diagoeau-field diagoeau-radio-group">
        <label>Politique de restriction</label>
        {POLITIQUES.map((p) => (
          <label key={p.value}>
            <input
              type="radio"
              checked={polSubv === p.value}
              onChange={() => setPolSubv(p.value)}
            />
            {p.label}
          </label>
        ))}
      </div>
    </>
  );
}